// Modules
// Material-ui
import { styled } from '@mui/material/styles';
import Switch, { switchClasses, type SwitchProps } from '@mui/material/Switch';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: '60px',
  height: '40px',
  padding: '7px',
  paddingTop: '6px',
  top: '1px',
  color: 'white',
  left: '1px',
  ['& .Mui-checked']: {
    color: 'white',
    left: 'calc(5% - 1px)',
  },
  [`& .Mui-checked + .${switchClasses.track}`]: {
    opacity: 1,
    backgroundColor: theme.mainColor,
  },
  [`& .${switchClasses.track}`]: {
    backgroundColor: COLORS.GRAY_SHADE_10,
    borderRadius: '13px',
    opacity: 1,
    height: '26px',
    width: '46px',
  },
  // Disabled styles
  [`& .${switchClasses.switchBase}.Mui-disabled`]: {
    color: COLORS.DISABLED_BUTTON_BG,
    '& + .MuiSwitch-track': {
      backgroundColor: COLORS.DISABLED_LINK,
      opacity: 0.5,
    },
  },
})) as React.ComponentType<SwitchProps>;

export default StyledSwitch;
